export default "__VITE_ASSET__BJNErd5E__"